import React from 'react';
import PropTypes from  'prop-types';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import  { withStyles } from  '@material-ui/core/styles';
import moment from 'moment'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';


import EmailIcon from '@material-ui/icons/Email';
import LinkIcon from '@material-ui/icons/Link';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import IconButton from '@material-ui/core/IconButton';


//import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
//import ExpandLess from '@material-ui/icons/ExpandLess';
//import ExpandMore from '@material-ui/icons/ExpandMore';
import Switch from '@material-ui/core/Switch';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';  
import Paper from '@material-ui/core/Paper';  
import validator from 'validator';


const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  gridListRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
  //  height: 450,
  },
  grid: {
    width: '100%',
  },
  paper:{
    marginTop: theme.spacing.unit * 2
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});


function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}


TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};


class DestinationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      values: {},
      updated: {},
      checked: [],
      attributes: [],
      destination: '',
      authCode:'',
      validDestination: true
    }
  }
  componentDidMount() {
  //  const values = {...this.props}
    this.setState({...this.props}, () => {
   //  this.mergeAttributesWithDefault()
    })
  }
  mergeAttributesWithDefault = () => {
    const { attributes, destinationType } = this.state
    const { destinationAttributes } = this.props

    

    const fields = Object.keys(destinationAttributes)
    const checked = []
    
    const allAttributes = fields.map(field => {
          if(!destinationType){
            checked.push(field)
            return {mapTo: destinationAttributes[field].field, ...destinationAttributes[field], isSelected: true}
          }
          const found = attributes.filter(attribute => {
              return attribute.field === field
          })

          if (found.length > 0){
              checked.push(field)
              return {...found[0], ...destinationAttributes[field], isSelected: true}
          }

          return {mapTo: destinationAttributes[field].field, ...destinationAttributes[field]}
    })

    allAttributes.sort(function(a, b){
      var keyA = a.field,
          keyB = b.field;
      // Compare the 2 dates
      if(keyA < keyB) return -1;
      if(keyA > keyB) return 1;
      return 0;
    });

    this.setState({attributes: allAttributes, checked})
  }
  handleToggleStatus = (value) => {
    const { checked, attributes } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    const newAttributes = attributes.map(attribute => {
        if(value === attribute.field){
          attribute.isSelected = true
        }
        return attribute 
    })

    this.setState({
      checked: newChecked,
      attributes: newAttributes
    });
  };
  handleSave = (status) => {
    const { destID, destinationAttributes } = this.props  
    const { checked, destination, destinationType, crmDestination, authCode } = this.state
    const { standard } = destinationAttributes
    let attributes = [...standard]
    if(crmDestination in destinationAttributes){
      attributes = [...destinationAttributes[crmDestination]]
    }


   
    const updateItem = {destID, status, modified: moment().format(), destination: destination.trim(), destinationType, crmDestination, authCode, attributes }
   
    this.props.handleClose(updateItem)
  };
  handleCancel = () => {
    this.props.handleClose()
  };
  handleMappingChange = (field, value) => {
    const { attributes } = this.state
    const sliceOfAttributes = attributes.slice()
    for (const attribute of sliceOfAttributes) {
        if (attribute.field === field){
          attribute.mapped = value
        }
    }
    console.log(sliceOfAttributes)
    this.setState({attributes: sliceOfAttributes})
  }
  handleOptionChange = (field, value) => {
    const { destinationType } = this.state

    //const temp = {}
   // temp[field] = value
    let validDestination = false
    if(field === 'authCode' || field === 'sfoid'){
      validDestination = true
    }else{
      if(destinationType === 'email'){
        validDestination = validator.isEmail(value)
      }else if(destinationType === 'url'){
        validDestination = validator.isURL(value, {protocols: ['http','https']})
      }
    }


    const temp = {[field]:value.trim(), validDestination }
    
    console.log('handleOptionChange')
    console.log(temp)
    this.setState(temp)
  }
  handleTypeSelection = (destinationType) => {
    this.setState({destinationType})
  }
  makeFieldList = (itemsArray) => {
    const { classes } = this.props
    let count = 0
    return itemsArray.map(item => {
      count = count + 1;
      const indexName = `open${count}`;
        return (<Grid key={indexName} item>

                  <TextField
                  key={item.attribute}
                  id={item.attribute}
                  label={item.name}
                  className={classes.textField}
                  value={item.mapped}
                  onChange={(event) => {this.handleMappingChange(item, event.target.value)}}
                  margin="normal" 
                  helperText={`Default: ${item.field}`}
                  />
                  <Switch
                  onChange={() => {this.handleToggleStatus(item.field)}}
                  checked={this.state.checked.indexOf(item.field) !== -1}
                  />
  
          </Grid>)
        })
  }

  makeListItems = () => {
    const { attributes } = this.state
    const { classes } = this.props

    const left = attributes.slice(0, attributes.length/2);
    const right = attributes.slice(attributes.length/2, attributes.length - 1)
  
          return (
            <Paper
            className={classes.paper}
          >
            <Grid item xs={12} className={classes.grid}>

            <Grid
              item xs={6}
              container
              alignItems={'flex-start'}
              direction={'column'}
              justify={'center'}>
              {this.makeFieldList(left)}
            </Grid>

            <Grid
            item xs={6}
            container
            alignItems={'flex-end'}
            direction={'column'}
            justify={'center'}>
            {this.makeFieldList(right)}
          </Grid>
          </Grid> </Paper>)
  }
  renderContentForNew = () => {
    const { classes } = this.props
    const { destinationType } = this.state;
    return (
    <DialogContent>
      <div className={classes.gridListRoot}>
    <GridList cellHeight={50} className={classes.gridList}>
        <GridListTile key={1}>
            <Typography className={classes.title} color="textSecondary">
            <IconButton onClick={() => {this.handleTypeSelection('email')}}>
            <EmailIcon />
          </IconButton>
            Send leads to your email
          </Typography>
        </GridListTile>
        <GridListTile key={2}>
        <Typography className={classes.title} color="textSecondary">
        <IconButton onClick={() => {this.handleTypeSelection('url')}}>
          <LinkIcon />
        </IconButton>
                Send leads to your crm or other web destination
        </Typography>
    </GridListTile>
    </GridList>       
    </div>
    </DialogContent>
  )

  }
  renderContentForExisting = () => {
    const { classes } = this.props
    const { destination, destinationType, crmDestination, validDestination, authCode } = this.state;
    if(crmDestination === 'topbrokercrm'){
      return (
        <DialogContent>
           <TextField
           fullWidth
           error={!validDestination}
          // key={destinationType}
           id={destinationType}
           label={`Please enter your ${destinationType}`}
           className={classes.textField}
           value={destination.trim()}
           onChange={(event) => {this.handleOptionChange('destination', event.target.value)}}
           margin="normal"
           />
           <TextField
           fullWidth
        //   key={destinationType}
           id={destinationType}
           label={`Please enter your authorization code provided to you by Top Broker`}
           className={classes.textField}
           value={authCode.trim()}
           onChange={(event) => {this.handleOptionChange('authCode', event.target.value)}}
           margin="normal"
           />
           <FormHelperText id="topbroker-helper-text">Please see your Top Broker CRM help section for assistance with creating an authorization code</FormHelperText>
       </DialogContent>
   );

    }else if(crmDestination === 'salesforce'){
        //need to make options for fields
    }

    return (
         <DialogContent>
            <TextField
            fullWidth
            error={!validDestination}
            //key={destinationType}
            id={destinationType}
            label={`Please enter your ${destinationType}`}
            className={classes.textField}
            value={destination.trim()}
            onChange={(event) => {this.handleOptionChange('destination', event.target.value)}}
            margin="normal"
            />
            {/*this.makeListItems()*/}
        </DialogContent>
    );
  }

  // this.setState({destinationType})

  renderCRMOptions = () => {
    const { classes } = this.props

    return (
    <DialogContent>
      <div className={classes.gridListRoot}>
    <GridList cellHeight={50} className={classes.gridList}>
        <GridListTile key={1}>
            <Button onClick={() => {this.setState({crmDestination: 'vanillasoft'})}}>Vanillasoft</Button>
        </GridListTile>

        {/*<GridListTile key={2}>
           //need to make options for fields
          <Button onClick={() => {this.setState({crmDestination: 'salesforce'})}}>Salesforce</Button>
    </GridListTile>*/}
        <GridListTile key={2}>
          <Button onClick={() => {this.setState({crmDestination: 'topbrokercrm'})}}>Top Broker</Button>
        </GridListTile>
    </GridList>       
    </div>
    </DialogContent>
    )
  }
  render() {
    const { classes, open } = this.props
    const { value, values, destination, destinationType, crmDestination, validDestination } = this.state;

      return (
        <Dialog
        open={open}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
      <div className={classes.root} style={{width:'600px'}}>
      <DialogTitle id="form-dialog-title">{destinationType ? 'Destination Settings'  : 'Choose Delivery Option'} </DialogTitle>
      {destinationType ? (crmDestination ? this.renderContentForExisting() : destinationType === 'email' ? this.renderContentForExisting() : this.renderCRMOptions())  : this.renderContentForNew()} 
   
      <DialogActions>
      <Button onClick={this.handleCancel} color="primary">
        Cancel
      </Button>
        <Button onClick={() => this.handleSave('deleted')} color="primary">Delete</Button>
        {destinationType && (destinationType === 'email' || crmDestination) && validDestination ?  <Button onClick={() => this.handleSave('active')} color="primary">Save</Button>  : null} 
      </DialogActions>
       </div>
      </Dialog>)
  }
}

DestinationDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DestinationDialog);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Destinations/DestinationDialog.js